import { gql } from 'graphql-request';

export const getTestConfiguration = gql`
  query GetTestConfiguration($id: String!) {
    test(id: $id) {
      id
      type
      name
      namespace
      resource {
        name
        type
      }
      tableAsset {
        id
        type
        name
        tableType
      }
      config {
        type
        muted
        ... on AnomalyDetectionTestConfig {
          anomaly_config: anomalyConfig {
            anomaly_direction: anomalyDirection
            detection_period: detectionPeriod {
              count
              period
            }
            sensitivity
            training_period: trainingPeriod {
              count
              period
            }
            excluded_time_ranges: excludedTimeRanges {
              start_time: startTime
              end_time: endTime
            }
            spike_threshold: spikeThreshold
            drop_threshold: dropThreshold
          }
          severity
          tags
          owners
        }
        ... on FreshnessAnomalyDetectionTestConfig {
          anomaly_config: anomalyConfig {
            sensitivity
            fixed_threshold: fixedThreshold {
              count
              period
            }
            training_period: trainingPeriod {
              count
              period
            }
          }
          severity
          tags
          owners
        }
        ... on QueryTestConfig {
          config
          tags
          owners
          severity
          errorIf
          warnIf
          description
        }
        ... on YamlTestConfig {
          config
          tags
          owners
          severity
          errorIf
          warnIf
          description
        }
        ... on SourceFreshnessTestConfig {
          config
        }
        ... on DataContractTestConfig {
          enforcementLevel
          baselineColumns {
            columnName
            dataType
            isNullable
          }
        }
        ... on PipelineTaskPerformanceTestConfig {
          mode
          sensitivity
          training_period: trainingPeriod {
            count
            period
          }
          anomaly_direction: anomalyDirection
          fixed_threshold: fixedThreshold {
            count
            period
          }
          severity
          owners
          tags
        }
      }
    }
  }
`;

export const getTestConditionalAlertDestinations = gql`
  query GetTestConditionalAlertDestinations($id: String!) {
    test(id: $id) {
      conditionalAlertDestinations {
        id
        type
        channel
        configurationType
        ruleId
        conditions {
          statuses
        }
      }
    }
  }
`;
